<script>
	import { base } from '$app/paths';
	import { page } from '$app/stores';
	import './sourceStyles.css';
	import './publicDocs.css';
	const root = `${base}/cinema-sign`;
</script>

<div class="cinema-sign-page">
	<header class="site-header">
		<div class="wrap nav">
			<a class="brand" href={`${root}/about/`}>
				<img src={`${base}/cinema-sign/cinema-sign-mark.svg`} alt="" width="42" height="42" />
				<span><strong>Cinema Sign</strong><small>Free cinema signage for Android TV</small></span>
			</a>
			<nav class="nav-links" aria-label="Cinema Sign">
				{#each [['about', 'About'], ['features', 'Features'], ['data-sources', 'Data sources'], ['deployment', 'Deployment'], ['operator-guide', 'Quick guide'], ['manual', 'User manual']] as [slug, label]}
					<a
						href={`${root}/${slug}/`}
						aria-current={$page.url.pathname.replace(/\/$/, '') === `${root}/${slug}` ||
						(slug === 'manual' && $page.url.pathname.startsWith(`${root}/manual/`))
							? 'page'
							: undefined}>{label}</a
					>
				{/each}
				<a href="https://www.d-cine.net/cinema-sign-apk/get.php">Download</a>
			</nav>
		</div>
	</header>
	<main><slot /></main>
	<footer class="footer">
		<div class="wrap footer-row">
			<strong>Cinema Sign 4.1</strong><span
				>Written by James Gardiner · Free digital signage for cinemas · Reviewed 31 October 2026</span
			>
		</div>
	</footer>
</div>
